import { useState, useEffect, useCallback } from "react";
import { useAppContext } from "../contexts/app";
import { useAuth } from "./useAuth";
import { timeDiff } from "../utils/global";

const SESSION_DURATION_MINUTES = 59;
const WARNING_THRESHOLD_MINUTES = 54;

export const useSessionTimer = () => {
	const { loggedTime } = useAppContext();
	const { logout } = useAuth();
	const [timeRemaining, setTimeRemaining] = useState(SESSION_DURATION_MINUTES);
	const [showWarning, setShowWarning] = useState(false);

	const updateTime = useCallback(() => {
		if (!loggedTime) return;

		const diff = timeDiff(new Date().toISOString(), loggedTime, true);
		const remaining = SESSION_DURATION_MINUTES - diff;

		setTimeRemaining(remaining);
		setShowWarning(diff >= WARNING_THRESHOLD_MINUTES && diff < SESSION_DURATION_MINUTES);

		if (diff >= SESSION_DURATION_MINUTES) {
			logout();
		}
	}, [loggedTime, logout]);

	useEffect(() => {
		if (!loggedTime) return;

		updateTime(); // Initial calculation
		const interval = setInterval(updateTime, 60000); // Update every minute

		return () => clearInterval(interval);
	}, [loggedTime, updateTime]);

	return { timeRemaining, showWarning };
};
